module.exports = __webpack_public_path__ + "static/plant-pathology-85db225495f023c11083b2a49ab9b6b3.jpg";